import React, { useState } from 'react'; 
import UnifiedGallery from '../components/UnifiedGallery';
import useStandardGallery from '../hooks/useStandardGallery';

const JeepPage = () => {
  // Use standardized gallery hook with consistent configuration
  //const { getGalleryProps } = useStandardGallery('jeep');
  const { getGalleryProps, loading, error, photos, refreshPhotos } = useStandardGallery('jeep', {
    // FEATURES CONFIGURATION
    features: {
      slideshow: true,              // Enable slideshow functionality
      thumbnails: true,             // Show thumbnail navigation
      fullscreen: true,             // Enable fullscreen mode
      zoom: true,                   // Enable zoom functionality
      captions: true,               // Show photo captions
      sharing: false,               // Enable sharing buttons (default: false)
      
      // PERFORMANCE FEATURES
      lazyLoading: true,            // Enable lazy loading for better performance
      imageOptimization: true,      // Enable image optimization
      preloadAdjacent: 2            // Number of adjacent images to preload (2 on each side)
    },
    
    // LAYOUT CONFIGURATION
    layout: {
      thumbnailSize: 220,           // Size of thumbnails in pixels
      maxDisplay: null,             // Maximum number of photos to display (null = all)
      columns: 'auto',              // Number of columns: 'auto', 1, 2, 3, 4, etc.
      spacing: 'default'            // Spacing between photos: 'compact', 'default', 'wide'
    },
    
    // PERFORMANCE CONFIGURATION
    performance: {
      enableIntersectionObserver: true,    // Use Intersection Observer for performance
      rootMargin: 50,                      // Root margin for Intersection Observer (pixels)
      enableWebP: true,                    // Enable WebP format support
      enableProgressiveLoading: true       // Enable progressive image loading
    }
  });

  const [showMore, setShowMore] = useState(false);

  const handleCelebration = () => {
    setShowMore(!showMore);
  };

  return (
    <div className="page-container-wrapper max-width-default padding-default">
      <div className="page-header">
        <h1>
          <i className="fas fa-car"></i>
          Jeep
        </h1>
        <p>Adventure awaits with Jeep! Born from military heritage and built for exploration, Jeep represents freedom, capability, and the spirit of adventure.</p>
      </div>

      <div className="page-content">
        <div className="section">
          <p>
            Adventure awaits with <b>Jeep!</b> Born from military heritage and built for exploration, Jeep represents freedom, capability, and the spirit of adventure.
        My rugged Wrangler can conquer mountain trails, race the waves on the beach, or cruise the city streets. Jeep vehicles are designed to go anywhere and do anything.
          </p>
        </div>

        {/* Jeep Gallery */}
        <div className="section">
          <UnifiedGallery 
            {...getGalleryProps("Jeep Adventures")}
          />
        </div>

        {showMore && (
          <div className="section">
            <div className="extended-intro">
              <p>My Jeep Wrangler is a 1995-Jeep-YJ (yes, it has square headlights). I became the proud owner of it in 2015, I won't bore you with all of the history, but if you really want to know you'll need to ask me in person.</p>
        <p>This is where I need to send out some love to all the folks that have been helping me renovate my Jeep. If your a Jeep owner going through the process, you know it's a long & tedious journey, perfect for a Jeep.

        <table align="center" border="0" celspacing="1" cellpadding="1" width="100%">
          <tr>
            <td align="left">
            <strong><u>MVPs</u></strong>
              <li>Dean Ciafraglione</li>
              <li>Fonze Fragola</li>
              <li>Sal Infantio</li>
              <li>Joey Tellerico</li>
              <li>Attilio Volpe</li>
              <br></br>
            <strong><u>Platinum Sponsors</u></strong>
              <li>Fragola Performance Systems</li>
              <li>Jay Sons Screw Machine Products</li>
              <li>Volpe & Son's</li>
              <br></br>
            <strong><u>Gold Sponsors</u></strong>
              <li>Crushtheogre's Used Jeep Parts</li>
              <li>Don Stevens Tire</li>
              <li>Expert Auto Glass</li>
              <li>Perreault's Radiator Shop</li>
              <li>RoBrand</li>
              <li>Shop Supply Services</li>
              <br></br>
            <strong><u>Silver Sponsors</u></strong>
              <li>Advance Auto Parts</li>
              <li>AutoZone</li>
              <li>Eastwood</li>
              <li>Extreme Terrain</li>
              <li>Fraser Engine</li>
              <li>Jegs</li>
              <li>Napa</li>
              <li>Quadratec</li>
              <br></br>
            <strong><u>Honorable Mention</u></strong>
              <li>Home Depot</li>
              <li>Lowe's</li>
              <li>Mad Hatter Muffler</li>
              <li>Southington Power Sports</li>

            </td>
          </tr>
        </table>
        </p>
            </div>
          </div>
        )}

        <div className="section">
          <div className="cta-buttons">
            <button className="cta-btn primary" onClick={handleCelebration}>
              <i className="fas fa-car"></i>
              {showMore ? 'Less' : 'My Jeep'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JeepPage;
